
export const formatPhoneNumberInput = (value) => {
  const cleaned = value.replace(/\D/g, '').slice(0, 10); // max 10 digits
  const length = cleaned.length;

  if (length < 4) return cleaned;
  if (length < 7) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};

